import { teachers } from '../data/teachers'
import { Teacher, TeacherDocumentKind } from '../types/teacher'

type Listener = () => void

// Anagrafica Docenti: the same list used by the Docenti section and by the
// teacher pickers of the course forms
class TeachersStore {
  private teachers: Teacher[] = [...teachers]
  private listeners = new Set<Listener>()
  private nextId = teachers.length + 1

  getAll(): Teacher[] {
    return this.teachers
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener)
    return () => {
      this.listeners.delete(listener)
    }
  }

  save(teacher: Omit<Teacher, 'id'> & { id?: string }): Teacher {
    if (teacher.id && this.teachers.some((t) => t.id === teacher.id)) {
      const saved = teacher as Teacher
      this.teachers = this.teachers.map((t) => (t.id === saved.id ? saved : t))
      this.emit()
      return saved
    }
    const saved: Teacher = {
      ...teacher,
      id: `t-${String(this.nextId++).padStart(2, '0')}`,
    }
    this.teachers = [...this.teachers, saved]
    this.emit()
    return saved
  }

  remove(id: string) {
    this.teachers = this.teachers.filter((t) => t.id !== id)
    this.emit()
  }

  // Records the upload with its date and time
  uploadDocument(id: string, kind: TeacherDocumentKind, fileName: string) {
    this.teachers = this.teachers.map((t) =>
      t.id === id
        ? {
            ...t,
            documents: {
              ...t.documents,
              [kind]: { fileName, uploadedAt: new Date().toISOString() },
            },
          }
        : t,
    )
    this.emit()
  }

  private emit() {
    this.listeners.forEach((l) => l())
  }
}

export const teachersStore = new TeachersStore()
